'use strict';

function StaticElement() {
    this.initStaticElement = function () {
        this.setStaticElement();
    };

    /********************************/
    // set static element
    /********************************/
    this.setStaticElement = function () {

        var element = $('#static-element');
        var elementPosition = 0;

        if(element.length){
            elementPosition = element.offset();

            $(window).scroll(function(){
                if($(window).scrollTop() > elementPosition.top){
                    element.css('position','fixed').css('top','0');
                } else {
                    element.css('position','static');
                }
            });
        }
    };
}
